import store from '@/store'

/**
 * 表格中，类型转文本
 * @returns
 */
export function type2Label(typeList, val) {
  if (!typeList) return '-'
  for (const item of typeList) {
    if (Number(item.value) === Number(val)) {
      return item.label
    }
  }
}
/**
 * 表格中，类型转成带颜色的文本
 * @returns
 */
export function type2ColorLabel(typeList, val) {
  for (const item of typeList) {
    if (item.value === val) {
      return <span style={{ color: item.color }}> {item.label}</span>
    }
  }
}

/**
 * 表格中，类型转成带标签的文本
 * @returns
 */
export function type2TagLabel(typeList, val) {
  for (const item of typeList) {
    if (item.value === val) {
      return <span class={item.tagClassName}> {item.label}</span>
    }
  }
}

/**
 * 防抖
 * @returns
 */
export function debounce(func, wait) {
  let timeout

  return function () {
    let context = this // 保存this指向
    let args = arguments // 拿到event对象

    clearTimeout(timeout)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, wait)
  }
}

// 根据设置，获取表格表头
export function getTableColumns(key, columns) {
  let target = store.state.columnsModule[key]

  if (target && target.colInfo.length == columns.length) {
    return target.colInfo.filter((col) => {
      return col.isShow === true
    })
  }
  return columns
}
